import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSchemaBuilder implements SchemaBuilder {
  constructor(private winRef: WindowRef) {}

  build(): Observable<Record<string, any>> {
    return of(this.collect());
  }

  protected collect(): Record<string, any> {
    return {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'ООО Строительный двор',
      alternateName: 'Строительный двор',
      address: {
        '@type': 'PostalAddress',
        postalCode: '625032',
        addressCountry: 'RU',
        addressRegion: 'Тюменская область',
        addressLocality: 'г.Тюмень',
        streetAddress: 'ул.Панфиловцев, д.86, оф.201',
      },
      telephone: '88003335577',
      email: 'mail@sdvor.com',
      faxNumber: '88003335577',
      url: this.winRef.location.origin,
      sameAS: [
        'https://www.youtube.com/channel/UCpTwMnsBpUR8sZXBjMlY4pg',
        'https://t.me/strdvor',
        'https://vk.com/strdvor',
        'https://ok.ru/group/58414278967359',
        'https://ru.wikipedia.org/wiki/%D0%A1%D1%82%D1%80%D0%BE%D0%B8%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9_%D0%B4%D0%B2%D0%BE%D1%80',
        'https://api.whatsapp.com/send?phone=79097346728',
      ],
    };
  }
}
